:host {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    position: relative;
}

.node {
    color: var(--color-layout-contrast);
    padding: 20px;
    text-align: left;

    &::after {
        content: '';
        display: block;
        position: absolute;
        background-color: currentColor;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin: auto;
        transition:
            transform 500ms ease,
            opacity 500ms ease;
        opacity: 0;
        top: 0;
        right: 100%;
        bottom: 0;
        left: unset;
    }

    &:hover,
    &:focus {
        color: var(--color-layout-highlight);

        &::after {
            opacity: 0.5;
            transform: translateX(5px);
        }
    }

    &[disabled] {
        &:hover,
        &:focus,
        & {
            color: var(--color-layout-contrast);

            &::after {
                display: none;
            }
        }
    }
}

:host(.open) .node::after,
:host(.active_within) .node::after,
.link-active.node::after {
    color: var(--color-layout-highlight);
    transform: translateX(10px);
    opacity: 1;
}

nav {
    display: none;
    flex-direction: column;
    overflow: hidden;
    transition: height 300ms ease;
}

:host(.visible) nav {
    display: flex;
}

:host(.visible:last-child) nav es-nav-node-2:last-child {
    margin-bottom: 20px;
}
